

<div class="acquisition_top" style="display:block;">
  <!-- top left part  -->


  <!-- top right part -->

  <div class="filter_search">
    <div class="search_container">
      <input type="text"  #search class="default_input search search_land" placeholder="Search" />
      <em class="ti-search"></em> 
    </div>
    <!-- <button class="default_secondary-btn filter" (click)="onFilter()">Filter <em class="ti-filter"></em> </button> -->
    <!-- <button class="default_secondary-btn Add_new" (click)="createEvent()">Create New<em class="ti-plus"></em> </button> -->
  </div>
</div>

